import {setScreen} from '../../services/router';
import NotificationCreate from './NotificationCreate';

export default function NotificationCreatePage() {
  return <NotificationCreate />;
}
